// Copyright (c) StrangeBee 2024

import { useLocalMessage } from '@Helpers/';
import { Divider, Space } from 'antd';
import React, { ReactElement } from 'react';
import { ICONS } from '@Constants/iconsApp';

const DividerFilter = (): ReactElement => {
    const i = useLocalMessage();
    return (
        <Divider>
            <Space>
                <ICONS.FilterOutlined className="color-primary" />
                <span className="title-3b color-primary">{i('dashboard.form-divider.filters')}</span>
            </Space>
        </Divider>
    );
};

export default DividerFilter;
